import {fetchActionCode, fetchTemplate, uploadBatch, uploadBatchFinal} from '../Actions/batchAction';

export default (dispatch) => {
    return {
        uploadBatch: (data: FormData) => {
            dispatch(uploadBatch(data));
        },
        uploadBatchFinal: (data: FormData) => {
            dispatch(uploadBatchFinal(data));
        },
        fetchActionCode: () => {
            dispatch(fetchActionCode());
        },
        fetchTemplate: () => {
            dispatch(fetchTemplate());
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/batchDispatch.ts